import { connect } from "react-redux";

import CustomerAgreementComponent from "./component";

const CustomerAgreement = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {},
)(CustomerAgreementComponent);

export default CustomerAgreement;
